export default __webpack_public_path__ + "static/networking_w.8142c6840d78db55171d275512125a08.png";